export const getProfileRequest = (fansUnitedSDK) => {
	try {
		const result = fansUnitedSDK.profile.getOwn().getInfo();
		return result;
	} catch (error) {
		throw error;
	}
};
